export const title = 'Trinity Consultants is growing';
export const blurb = 'Watch the video and find out where we’re headed';
